export default __webpack_public_path__ + "static/gc-icon-d4dae6dbf6325a6bd183b322f34d9417.png";